module.exports = __webpack_public_path__ + "static/klarna-7bbd75f3bb1cde5bd2f9014d104a7dc7.png";